import React, { useEffect } from 'react';
import StepsLayout, {
  TypeLayout
} from 'screens/Applications&WorkOrders/StepsLayout';
import { OperationType } from 'screens/Applications&WorkOrders/RouteAdmin';
import useConversionInvoiceToOperation from './Hooks/useConversionInvoiceToOperation';

export const CreateOperationFromInvoice: React.FC = () => {
  const {
    isLoading,
    operationType,
    convertInvoiceToOperationFormikData
  } = useConversionInvoiceToOperation();

  useEffect(() => {
    convertInvoiceToOperationFormikData();
  }, [convertInvoiceToOperationFormikData]);

  const type =
    operationType === OperationType.APPLICATION
      ? TypeLayout.APPLICATION
      : TypeLayout.WORK_ORDER;
  return <StepsLayout isLoading={isLoading} type={type} />;
};

export default CreateOperationFromInvoice;
